import React from 'react'

const HelpPhone = () => (
    <span>212-318-2000</span>
) 

export default HelpPhone